const clientIdMap = {
    [process.env.VUE_APP_ALVORADA_SUSTENTAVEL_URL]:
        process.env.VUE_APP_KEYCLOAK_ALVORADA_SUSTENTAVEL_CLIENT_ID,
    [process.env.VUE_APP_BUNGE_URL]:
        process.env.VUE_APP_KEYCLOAK_BUNGE_CLIENT_ID,
    [process.env.VUE_APP_URL]: process.env.VUE_APP_KEYCLOAK_BUNGE_CLIENT_ID
};

const logoutMap = {
    [process.env.VUE_APP_ALVORADA_SUSTENTAVEL_URL]:
        process.env.VUE_APP_KEYCLOAK_ALVORADA_SUSTENTAVEL_LOGOUT_URL,
    [process.env.VUE_APP_BUNGE_URL]:
        process.env.VUE_APP_KEYCLOAK_BUNGE_LOGOUT_URL,
    [process.env.VUE_APP_URL]: process.env.VUE_APP_KEYCLOAK_LOGOUT_URL
};

function getClientId() {
    const urlAtual = Object.keys(clientIdMap).find(url =>
        window.location.host.includes(url)
    );

    return urlAtual
        ? clientIdMap[urlAtual]
        : process.env.VUE_APP_KEYCLOAK_CLIENT_ID;
}

function getLogoutUrl() {
    const urlAtual = Object.keys(logoutMap).find(url =>
        window.location.host.includes(url)
    );

    return urlAtual
        ? logoutMap[urlAtual]
        : process.env.VUE_APP_KEYCLOAK_LOGOUT_URL;
}

export default {
    getClientId,
    getLogoutUrl
};
